const STORAGE_KEY = 'sabhia-test-access'
const TOKEN_REGEX = /^[A-Za-z0-9-]{4,128}$/

function isBrowser(): boolean {
  return typeof window !== 'undefined' && typeof localStorage !== 'undefined'
}

function isFeatureEnabled(): boolean {
  const flag = import.meta.env?.VITE_TEST_PAGE_ENABLED
  if (flag == null) return true
  if (typeof flag === 'string') {
    const normalized = flag.trim().toLowerCase()
    return normalized === '1' || normalized === 'true' || normalized === 'yes'
  }
  return Boolean(flag)
}

export class TestAuthService {
  private static normalizeToken(token: string): string {
    return String(token || '').trim()
  }

  static isFeatureEnabledPublic(): boolean {
    return isFeatureEnabled()
  }

  static async verificarToken(token: string): Promise<{ success: boolean; error?: string }> {
    const normalized = this.normalizeToken(token)

    if (!normalized || !TOKEN_REGEX.test(normalized)) {
      return { success: false, error: 'INVALID_TOKEN' }
    }

    try {
      const response = await fetch('/api/verify-test-token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: normalized }),
      })

      const isJson = response.headers.get('content-type')?.includes('application/json')
      const payload = isJson ? await response.json() : undefined

      if (!response.ok) {
        const code = payload?.error || payload?.code || 'INVALID_TOKEN'
        return { success: false, error: code }
      }

      const valid = payload?.valid === true
      if (!valid) {
        return { success: false, error: 'INVALID_TOKEN' }
      }

      return { success: true }
    } catch (error) {
      console.error('Erro ao verificar token de testes:', error)
      return { success: false, error: 'NETWORK_ERROR' }
    }
  }

  static salvarAcesso(): void {
    if (!isBrowser()) return
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ grantedAt: Date.now() }))
    } catch (error) {
      console.warn('Não foi possível salvar o acesso de testes:', error)
    }
  }

  static verificarAcesso(): boolean {
    if (!isFeatureEnabled()) return false
    if (!isBrowser()) return false
    try {
      return localStorage.getItem(STORAGE_KEY) != null
    } catch (error) {
      console.warn('Não foi possível verificar o acesso de testes:', error)
      return false
    }
  }

  static removerAcesso(): void {
    if (!isBrowser()) return
    try {
      localStorage.removeItem(STORAGE_KEY)
    } catch (error) {
      console.warn('Não foi possível remover o acesso de testes:', error)
    }
  }
}
